import actionTypes from "../actionTypes"

const updateSelectedAlias = alias => {
  return {
    type: actionTypes.SET_SELECTED_ALIAS,
    payload: alias,
  }
}

export default {
  updateSelectedAlias,
}